export default {
    slide: (object) => {
        $.fn.isInViewport = function () {
            const elementTop = $(this).offset().top;
            const elementBottom = elementTop + $(this).outerHeight();
            const viewportTop = $(window).scrollTop();
            const viewportBottom = viewportTop + $(window).height();
            return elementBottom > viewportTop && elementTop < viewportBottom;
        };

        const checkHomeBlockInViewPort = function () {
            $(object).each(function () {
                if ($(this).isInViewport() && !$(this).hasClass('in-viewport')) {
                    $(this).addClass('in-viewport');
                }
            });
        };

        $(window).on('resize', () => {
            checkHomeBlockInViewPort();
        });

        $(window).on('scroll', () => {
            checkHomeBlockInViewPort();
        });
    },
}